import { Button } from '@oniratec/onira-react-ui';
import { EntityFooterConfig } from '@/modules/ui/entity-footer/types';

type Props = {
  config: EntityFooterConfig;
};

export function EntityActionFooter({ config }: Props) {
  const { actions, leftSlot } = config;

  if (!actions?.length && !leftSlot) {
    return null;
  }

  return (
    <div
      className="
        z-40
        border-t bg-white
        shadow-[0_-4px_12px_rgba(0,0,0,0.06)]
      "
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 p-4">
        <div>{leftSlot}</div>

        <div className="flex items-center gap-2">
          {actions
            ?.filter(a => a.visible !== false)
            .map(action => (
              <Button
                key={action.key}
                variant={action.variant ?? 'secondary'}
                onClick={action.onClick}
                disabled={action.disabled}
                loading={action.loading}
              >
                {action.label}
              </Button>
            ))}
        </div>
      </div>
    </div>
  );
}
